import { FastFlowRedirectionReason } from './consts';
export const getFastFlowRedirectionReason = _ref => {
  let {
    shouldChooseShippingMethod,
    hasTermsAndConditions,
    hasCustomField,
    hasTaxZipCodeError,
    hasTaxSubdivisionError,
    hasShippingZipCodeError,
    hasShippingSubdivisionError,
    hasTotalAmountMismatchWithLatestSeen,
    hasViolations
  } = _ref;
  if (hasTermsAndConditions) {
    return FastFlowRedirectionReason.hasTermsAndConditions;
  }
  if (hasCustomField) {
    return FastFlowRedirectionReason.hasCustomField;
  }
  if (hasTaxZipCodeError) {
    return FastFlowRedirectionReason.hasTaxZipCodeError;
  }
  if (hasTaxSubdivisionError) {
    return FastFlowRedirectionReason.hasTaxSubdivisionError;
  }
  if (hasShippingZipCodeError) {
    return FastFlowRedirectionReason.hasShippingZipCodeError;
  }
  if (hasShippingSubdivisionError) {
    return FastFlowRedirectionReason.hasShippingSubdivisionError;
  }
  if (hasTotalAmountMismatchWithLatestSeen) {
    return FastFlowRedirectionReason.hasTotalAmountMismatchWithLatestSeen;
  }
  if (hasViolations) {
    return FastFlowRedirectionReason.hasViolations;
  }
  if (shouldChooseShippingMethod) {
    return FastFlowRedirectionReason.shouldChooseShippingMethod;
  }
  return FastFlowRedirectionReason.unknown;
};
//# sourceMappingURL=bi.util.js.map